module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8r9r2n5r-61dd193a67526d82d1f023edf6350041.svg";